export function newsroomSticky() {
    const $window = $(window);
    const $header = $(".header");
    let parent = $(".newsroom");
    let titleHolder = parent.find(".newsroom-title");
    let stickyBox = $(".newsroom-contact-box");

    $window.on("load scroll resize", function () {
        if (window.innerWidth >= 1200) {
            let BoxLeft = titleHolder.position().left + titleHolder.innerWidth();
            stickyBox.css({
                "left": BoxLeft,
            });
            let top = parent.offset().top;

            let headerHeight;
            if ($header.hasClass("colored")) {
                headerHeight = $header.innerHeight();
            }
            if ($window.scrollTop() > top - headerHeight - 20 && !stickyBox.hasClass("sticky")) {
                stickyBox.addClass("sticky").css({
                    "position": "fixed",
                    "top": headerHeight + 20,
                    "left": BoxLeft,
                    "bottom": "auto"
                });
            }
            if ($window.scrollTop() < top - headerHeight - 20 && stickyBox.hasClass("sticky")) {
                stickyBox.removeClass("sticky").css({
                    "position": "",
                    "top": "",
                    "left": BoxLeft
                });
            }
            if ($window.scrollTop() > top - headerHeight - 20 + parent.innerHeight() - stickyBox.innerHeight() && stickyBox.hasClass("sticky")) {
                stickyBox.removeClass("sticky").css({
                    "position": "",
                    "top": "auto",
                    "left": BoxLeft,
                    "bottom": "0"
                });
            }
        } else {
            // if ($window.scrollTop() < top + stickyBoxHeight - boxHeight - headerHeight && parent.hasClass("sticky")) {
            stickyBox.removeClass("sticky").attr("style", "");
            // }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/newsroomSticky.js